import React from 'react';
import JobResults from './components/job-results';
import Facets from './components/facets';
import Provider from './components/jobs-wrapper';

function App() {

  return (
      
      <Provider> 
        <section class="block-gray">
            <div class="job-search-block">
                <div class="container">
                    <div class="section-search-results">
                      <Facets />
                      <JobResults />
                    </div>
                </div>
            </div>
        </section>
      </Provider>
 
  );
}

export default App;
